module.exports = __webpack_public_path__ + "img/newImage1.bf43be6a.svg";